import React from "react";
import { Link } from "react-router-dom";

export default function SectionHeader({ overline, title, subtitle, align = "left" }) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl ${align === "center" ? "mx-auto" : ""}`}>
      {overline && <p className="overline mb-4">{overline}</p>}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-navy-800 leading-[1.1]">{title}</h2>
      {subtitle && <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function CTABar({ title, text, primary, secondary, testid = "cta-bar" }) {
  return (
    <section data-testid={testid} className="relative overflow-hidden bg-navy-900 text-white">
      <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: "radial-gradient(circle at 15% 20%, rgba(181,149,92,0.35), transparent 45%), radial-gradient(circle at 85% 80%, rgba(181,149,92,0.2), transparent 40%)",
      }} />
      <div className="container-tight relative py-20 lg:py-24 grid gap-8 lg:grid-cols-[1.4fr,1fr] items-center">
        <div>
          <p className="overline text-gold-400 mb-4">Ready when you are</p>
          <h3 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight">{title}</h3>
          {text && <p className="mt-4 text-white/75 max-w-xl leading-relaxed">{text}</p>}
        </div>
        <div className="flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
          {primary && (
            <Link to={primary.to} data-testid={`${testid}-primary`} className="btn-lift inline-flex justify-center items-center h-12 px-7 rounded-full bg-gold-500 hover:bg-gold-600 text-white font-medium tracking-wide">
              {primary.label}
            </Link>
          )}
          {secondary && (
            <Link to={secondary.to} data-testid={`${testid}-secondary`} className="btn-lift inline-flex justify-center items-center h-12 px-7 rounded-full border border-white/30 hover:bg-white/10 text-white font-medium tracking-wide">
              {secondary.label}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
